$(document).ready(function(){
           setTimeout( function () {
          var subscription_value = $('.subscription-radio .rc-radio__subscription').text();
              $('.onetime-radio .rc-radio__label').html('<strong>One-time purchase</strong>');
              $('.subscription-radio .rc-radio__subscription').html('<strong>'+subscription_value+'</strong>');
               $('.onetime-radio .rc-radio__label').after('<p class="u-h6 Guarantee__Text">No Subscription</p>');
               $('.subscription-radio .rc-radio__label').after('<p class="u-h6 Guarantee__Text">Pause & cancel anytime.</p>');
               var Product_price = $('.ProductOTP-Price').text();
              $('.onetime-radio .rc-radio__label').after('<span class="rc-radio__price_one"><strong>'+Product_price+'</strong></span>');
              var onetime_servingprice = $('.ontime-priceserving').text();
              $('.onetime-radio .Guarantee__Text').after('<p class="onetime_priceWrapper">($'+ onetime_servingprice +'/serving)</p>');
               var subscription_servingprice = $('.subscription-priceserving').text();
              $('.subscription-radio .Guarantee__Text').after('<p class="subscribe_priceWrapper">($'+ subscription_servingprice +'/serving)</p>');
              $('.rc-radio__label .rc-radio__price').after('<span class="Subscription__Price Subscription_ComparisionPrice Heading u-h6 FontWeight_Six"></span>');
             if ($('.onetime-radio span.rc-radio__price_one').length > 0) {
          	  document.querySelector('.Subscription__Price.Subscription_ComparisionPrice').textContent = document.querySelector('.onetime-radio span.rc-radio__price_one').textContent.trim();
             };
            $('.oke-w-mediaGridModule .oke-media--linked').removeAttr("role");
            $('.oke-mediaStrip-container.oke-w-mediaStrip').removeAttr("role");
            $('.oke-media--linked').removeAttr("role");
           $('.oke-w-reviews-list-item').each(function() {
             var negativeReview = $(this).find('.oke-helpful-vote-button--negative .oke-helpful-vote-counter').text();
             var positiveReview = $(this).find('.oke-helpful-vote-button--positive .oke-helpful-vote-counter').text();
            $(this).find('.oke-helpful-vote-button--negative').attr('aria-label', negativeReview);
            $(this).find('.oke-helpful-vote-button--positive').attr('aria-label', positiveReview);
           });
          }, 1600);
        });
        $(window).load(function(){
             var recommondedrating = $('.oke-w-header-content-module--left .oke-w-recommendsModule .oke-w-recommendsModule-value').html();
            console.log(recommondedrating);
            var Rating_value = $('.oke-w-header-content-module--left .oke-w-ratingAverageModule .oke-w-ratingAverageModule-rating  .oke-w-ratingAverageModule-rating-average').html();
        setTimeout( function () {
         $('.oke-w-recommendsModule .oke-w-recommendsModule-value').remove();
         $('.oke-w-recommendsModule .oke-w-recommendsModule-text').before('<span class="oke-w-recommendsModule-value"><strong>'+ recommondedrating +'</strong></span>');
        $('.oke-w-selectAttr-item-title').remove();
         $('.oke-w-reviews-list-item .oke-w-selectAttr-item-value').before('<span class="oke-w-selectAttr-item-title"><strong>I DRINK PIQUE FOR</strong></span>');
           $('.oke-w-ratingAverageModule .oke-w-ratingAverageModule-rating  .oke-w-ratingAverageModule-rating-average').remove();
          $('.oke-w-ratingAverageModule .oke-w-ratingAverageModule-rating  .oke-w-ratingAverageModule-rating-stars').before('<span class="oke-w-ratingAverageModule-rating-average"><strong>'+ Rating_value +'</strong></span>');
        },500);
        })
/* Product gallery slider Mobile */
!function () {
  "use strict";

  // Poll until a condition is met, then resolve. Times out after `timeout` ms.
  function waitFor(condition, timeout) {
    timeout = timeout || 10000;
    return new Promise(function (resolve) {
      var interval = setInterval(function () {
        if (condition()) {
          resolve(condition());
          clearInterval(interval);
          interval = null;
        }
      }, 500);
      setTimeout(function () {
        if (interval !== null) {
          clearInterval(interval);
          console.log("slider-width: condition not met before timeout");
        }
      }, timeout);
    });
  }

  function applyWidth() {
    var slideshow = document.querySelector(
      ".Product__Gallery .Product__Slideshow--zoomable"
    );
    if (!slideshow) return;

    // Set each cell to 83.333% width
    slideshow.querySelectorAll(".Carousel__Cell").forEach(function (cell) {
      cell.style.width = "83.333%";
    });

    // Resize Flickity so it recalculates positions with the new widths
    var flkty = Flickity.data(slideshow);
    if (flkty) flkty.resize();
  }

  waitFor(function () {
    return (
      window.innerWidth < 768 &&
      document.querySelector(
        ".Product__Gallery .Product__Slideshow--zoomable"
      ) != null && typeof Flickity === "function"
    );
  }).then(applyWidth);
}();
/* Product gallery — infinite scroll (mobile), always on */
!function () {
  "use strict";

  // Poll until a condition is met, then resolve. Times out after `timeout` ms.
  // (Same helper shape as the existing "Product gallery slider Mobile" script.)
  function waitFor(condition, timeout) {
    timeout = timeout || 10000;
    return new Promise(function (resolve) {
      var interval = setInterval(function () {
        if (condition()) {
          resolve(condition());
          clearInterval(interval);
          interval = null;
        }
      }, 500);
      setTimeout(function () {
        if (interval !== null) {
          clearInterval(interval);
          console.log("infinite-scroll: condition not met before timeout");
        }
      }, timeout);
    });
  }

  function enableInfiniteScroll() {
    var slideshow = document.querySelector(
      ".Product__Gallery .Product__Slideshow--zoomable"
    );
    if (!slideshow) return;

    var carousel = slideshow.closest(".Carousel");
    var flkty = Flickity.data(carousel);
    if (!flkty) return;

    flkty.options.wrapAround = true;
    flkty.resize();
  }

  waitFor(function () {
    return (
      window.innerWidth < 768 &&
      document.querySelector(
        ".Product__Gallery .Product__Slideshow--zoomable"
      ) != null &&
      typeof Flickity === "function" &&
      document.querySelector(".Product__Gallery .Carousel.flickity-enabled") != null
    );
  }).then(enableInfiniteScroll);
}();

!(function () {
  'use strict';

  function poll(predicate, timeoutMs) {
    timeoutMs = timeoutMs || 10000;
    return new Promise(function (resolve) {
      var id = setInterval(function () {
        var val = predicate();
        if (val) {
          resolve(val);
          clearInterval(id);
          id = null;
        }
      }, 500);
      setTimeout(function () {
        if (id !== null) {
          clearInterval(id);
          console.log('condition false');
        }
      }, timeoutMs);
    });
  }

  var CONFIG = {
    html: {
      atcPopupOverlay: '<div class="pt_472_atc_overlay"></div>',
      atcPopup: function (title) {
        return (
          '<div class="pt_472_atc_popup">\n' +
          '                              <div class="pt_472_atc_header">\n' +
          '                                 <h3>' + title + '</h3>\n' +
          '                                 <div class="pt_472_atc_close"><img src="https://cdn.shopify.com/s/files/1/2135/4367/files/Close-popup.png?v=1791181491"></div>\n' +
          '                              </div>\n' +
          '                              <div class="pt_472_atc_content">\n' +
          '                              </div>\n' +
          '                     </div>'
        );
      },
    },
  };

  var initAll = function (container) {
    (function (o) {
      var isCacaoChai = window.location.pathname === '/products/cacao-chai';

      poll(function () {
        return o.querySelector('.Sticky__Form > .Container') != null && o.querySelector('.ProductForm button.ProductForm__AddToCart') != null;
      }).then(function () {
        if (o.querySelector('.pt_472_atc_popup')) return;

        var realATCBtn = o.querySelector('.ProductForm button.ProductForm__AddToCart');
        if (realATCBtn) {
          var stickyClone = realATCBtn.cloneNode(true);
          stickyClone.classList.add('pt_472_is_sticky_clone');
          stickyClone.type = 'button';
          stickyClone.classList.remove('ProductForm__AddToCart');
          o.querySelector('.Sticky__Form > .Container').insertAdjacentElement('afterbegin', stickyClone);
        }

        var titleEl = o.querySelector('.ProductMeta .ProductMeta__Title');
        var productTitle = titleEl ? titleEl.textContent.trim() : '';
        var realForm = o.querySelector('.Container form.ProductForm');
        var formClone = realForm ? realForm.cloneNode(true) : null;

        function openATCPopup() {
          var overlay = o.querySelector('.pt_472_atc_overlay');
          var popup = o.querySelector('.pt_472_atc_popup');
          if (overlay) overlay.classList.add('pt_472_atc_active');
          if (popup) popup.classList.add('pt_472_atc_active');
          o.classList.add('pt_472_atc_open');
        }
        function closeATCPopup() {
          var overlay = o.querySelector('.pt_472_atc_overlay');
          var popup = o.querySelector('.pt_472_atc_popup');
          if (overlay) overlay.classList.remove('pt_472_atc_active');
          if (popup) popup.classList.remove('pt_472_atc_active');
          o.classList.remove('pt_472_atc_open');
        }

        o.insertAdjacentHTML('beforeend', CONFIG.html.atcPopupOverlay);
        o.insertAdjacentHTML('beforeend', CONFIG.html.atcPopup(productTitle));
        var popupContent = o.querySelector('.pt_472_atc_content');
        if (formClone) popupContent.appendChild(formClone);

        if (!isCacaoChai) {
          var stickyCloneEl = o.querySelector('.Sticky__Form .pt_472_is_sticky_clone');
          if (stickyCloneEl) stickyCloneEl.addEventListener('click', openATCPopup);
        }
        var closeBtn = o.querySelector('.pt_472_atc_close');
        if (closeBtn) closeBtn.addEventListener('click', closeATCPopup);
        var overlayEl = o.querySelector('.pt_472_atc_overlay');
        if (overlayEl) overlayEl.addEventListener('click', closeATCPopup);

        if (isCacaoChai) {
          var cacaoStickyBtn = o.querySelector('.pt_472_is_sticky_clone');
          if (cacaoStickyBtn) {
            cacaoStickyBtn.addEventListener('click', function (e) {
              e.preventDefault();
              var realBtn = o.querySelector('.Product__InfoWrapper .ProductForm__AddToCart');
              if (realBtn) realBtn.click();
            });
          }
          return; // cacao-chai's flow ends here, same as the original script
        }

        function getRealForm() {
          return o.querySelector('.Container > form.ProductForm');
        }

        var realFormForDetection = getRealForm();
        var usesNewDesign = !!(realFormForDetection && realFormForDetection.querySelector('.pt_option_group'));

        if (usesNewDesign) {
          /* ---- NEW design (.pt_option_group) ---- */

          function activateIntentOnReal(intent) {
            var form = getRealForm();
            if (!form) return;
            var label = form.querySelector(intent === 'onetime' ? '.pt_option--onetime' : '.pt_option--subscribe');
            var radio = label && label.querySelector('.pt_option_radio_input');
            if (radio && !radio.checked) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }

          function mirrorIntentIntoClone(intent) {
            var subLabel = popupContent.querySelector('.pt_option--subscribe');
            var oneLabel = popupContent.querySelector('.pt_option--onetime');
            if (!subLabel || !oneLabel) return;
            subLabel.classList.toggle('is-selected', intent === 'subscription');
            oneLabel.classList.toggle('is-selected', intent === 'onetime');
            var subRadio = subLabel.querySelector('.pt_option_radio_input');
            var oneRadio = oneLabel.querySelector('.pt_option_radio_input');
            if (subRadio) subRadio.checked = intent === 'subscription';
            if (oneRadio) oneRadio.checked = intent === 'onetime';

            var priceSource = intent === 'subscription' ? subRadio : oneRadio;
            var atcPrice = priceSource && priceSource.getAttribute('data-atc-price');
            if (atcPrice) {
              var atcPriceEl = popupContent.querySelector('.Quantity__PriceBtn, .pt396_addToCart_button_price');
              if (atcPriceEl) atcPriceEl.textContent = atcPrice;
            }
          }

          popupContent.addEventListener('click', function (e) {
            var wantsSubscriptionCTA = e.target.closest('.pt_switch_link, [data-switch-to="subscribe"]');
            var wantsOnetime = !wantsSubscriptionCTA && e.target.closest('.pt_option--onetime');
            var wantsSubscription = wantsSubscriptionCTA || e.target.closest('.pt_option--subscribe');
            if (!wantsOnetime && !wantsSubscription) return;
            var intent = wantsSubscription ? 'subscription' : 'onetime';
            activateIntentOnReal(intent);
            mirrorIntentIntoClone(intent);
          });

          var initialSubRadio = realFormForDetection.querySelector('.pt_option--subscribe .pt_option_radio_input');
          mirrorIntentIntoClone(initialSubRadio && initialSubRadio.checked ? 'subscription' : 'onetime');
        } else {
          /* ---- OLD design (.pt_413_*) — the original, proven-working
             checkbox-based mechanism. Each step individually null-guarded
             so a missing element skips just that step instead of
             throwing and taking down everything after it. ---- */

          var cloneOnetimeWrapper = popupContent.querySelector('.pt_413_onetime_wrapper');
          if (cloneOnetimeWrapper) cloneOnetimeWrapper.classList.remove('pt_413_hidden');

          var stickyCheckbox = o.querySelector('#sticky_toggleCheckbox');
          if (stickyCheckbox) {
            if (!stickyCheckbox.checked) o.classList.add('stickyToogle_enabled');
            stickyCheckbox.addEventListener('change', function (e) {
              o.classList.toggle('stickyToogle_enabled', !e.target.checked);
            });
          }

          var realSwitchCTA = realFormForDetection && realFormForDetection.querySelector('p.pt_413_onetime_left_lower_cta');
          if (realSwitchCTA) {
            realSwitchCTA.addEventListener('click', function () {
              var realToggleSwitch = realFormForDetection.querySelector('.pt_413_onetime_wrapper .pt_413_toggle_switch');
              if (realToggleSwitch) realToggleSwitch.click();
            });
          }

          popupContent.addEventListener('click', function (e) {
            var target = e.target;
            if ((target.closest('.pt_413_onetime_wrapper') || target.closest('.pt_413_subscription_wrapper')) && stickyCheckbox) {
              var lbl = stickyCheckbox.closest('label[for="sticky_toggleCheckbox"]');
              if (lbl) lbl.click();
            }
          });
        }

        /* Always runs, regardless of which buybox design is present —
           this is what makes "Add to Cart" inside the popup actually
           click the real (non-cloned) button instead of the orphaned
           clone's own submit behavior. */
        var popupATCBtn = popupContent.querySelector('button.ProductForm__AddToCart');
        if (popupATCBtn) {
          popupATCBtn.addEventListener('click', function (e) {
            e.preventDefault();
            poll(function () {
              var form = getRealForm();
              return form && form.querySelector('button.ProductForm__AddToCart') != null;
            }).then(function () {
              getRealForm().querySelector('button.ProductForm__AddToCart').click();
            });
          });
        }
      });
    })(container);
  };

  /* Bootstrap — unchanged */
  (function () {
    window.optiActiveTests = window.optiActiveTests || {};
    window.optiActiveTests['OP_PT_472'] = 'v1';

    poll(function () {
      return window.location.pathname.includes('/products/') && window.innerWidth < 768 && document.querySelector('main') !== null;
    }).then(function () {
      var body = document.body;
      body.classList.add('pt_472');
      initAll(body);
    });
  })();
})();